require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-mano-river-union-road-development-and-transport-facilitation.json") })
        }
      }, "path---en-us-project-mano-river-union-road-development-and-transport-facilitation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-mano-river-union-road-development-and-transport-facilitation!./.cache/json/en-us-project-mano-river-union-road-development-and-transport-facilitation.json
// module id = 541
// module chunks = 231608221292675